"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Markdown = void 0;

var _remark = _interopRequireDefault(require("remark"));

var _remarkBreaks = _interopRequireDefault(require("remark-breaks"));

var _remarkReact = _interopRequireDefault(require("remark-react"));

var Markdown = function Markdown(_ref) {
  var markdown = _ref.markdown,
      _ref$map = _ref.map,
      map = _ref$map === void 0 ? {} : _ref$map;
  return (0, _remark.default)().use(_remarkReact.default, {
    remarkReactComponents: map
  }).use(_remarkBreaks.default).processSync(markdown).contents;
};

exports.Markdown = Markdown;